import { z } from 'zod/v4';
import {
  COMPANY_DOCUMENT_LIST_SORT_COLUMNS,
  CompanyDocumentListItemSchema,
} from './list.js';

/** The plain list's sort keys, plus when the document was archived. */
export const COMPANY_DOCUMENT_ARCHIVED_LIST_SORT_COLUMNS = [
  ...COMPANY_DOCUMENT_LIST_SORT_COLUMNS,
  'archivedAt',
] as const;

export type CompanyDocumentArchivedListSortColumn =
  (typeof COMPANY_DOCUMENT_ARCHIVED_LIST_SORT_COLUMNS)[number];

const sortColumns = COMPANY_DOCUMENT_ARCHIVED_LIST_SORT_COLUMNS.join('|');
const SORT_PATTERN = new RegExp(
  `^(${sortColumns}):(ASC|DESC)(,(${sortColumns}):(ASC|DESC))*$`,
);

/**
 * The caller's own archived documents. Always the caller's company: there is
 * no `companyId`, and none of the plain list's mode flags.
 */
export const ListArchivedCompanyDocumentsQuerySchema = z.object({
  page: z.coerce.number().int().min(0).default(0),
  count: z.coerce.number().int().min(0).max(500).default(15),
  /** Defaults to most recently archived first. */
  sort: z.string().regex(SORT_PATTERN).optional(),
  /** Case-insensitive substring of the document name. */
  q: z.string().max(255).optional(),
  /** JSON object of column filters, as on the plain list. Malformed JSON is ignored. */
  filter: z.string().max(512).optional(),
});

export type ListArchivedCompanyDocumentsQuery = z.infer<
  typeof ListArchivedCompanyDocumentsQuerySchema
>;

export const CompanyDocumentArchivedListItemSchema =
  CompanyDocumentListItemSchema.extend({
    archivedAt: z.coerce.date().nullable(),
    archivedByUserName: z.string().nullable(),
    archivedByCompanyName: z.string().nullable(),
  });

export type CompanyDocumentArchivedListItem = z.infer<
  typeof CompanyDocumentArchivedListItemSchema
>;
